import React, { useState, useEffect } from 'react';

const Card = ({
    title, 
    children, 
    collapsible = false, 
    initiallyCollapsed = false,
    isExpanded = null,
    onToggle = null
}) => {
    const [internalCollapsed, setInternalCollapsed] = useState(initiallyCollapsed);
    
    // Use external control if provided, otherwise use internal state
    const isCollapsed = isExpanded !== null ? !isExpanded : internalCollapsed;

    // Update internal state when external isExpanded changes
    useEffect(() => {
        if (isExpanded !== null) {
            setInternalCollapsed(!isExpanded);
        }
    }, [isExpanded]);

    const toggleCollapse = () => {
        if (collapsible) {
            if (onToggle) {
                // Use external control
                onToggle();
            } else {
                // Use internal state
                setInternalCollapsed(!internalCollapsed);
            }
        }
    };

    if (!collapsible) {
        // Non-collapsible card (original behavior)
        return (
            <div className="reports-card">
                {title && <h2>{title}</h2>}
                {children}
            </div>
        );
    }

    // Collapsible card
    return (
        <div className={`reports-card ${isCollapsed ? 'collapsed-state' : ''}`}>
            <div
                className={`reports-card-header ${isCollapsed ? 'collapsed' : ''}`}
                onClick={toggleCollapse}
            >
                <h2>{title}</h2>
                <div className="reports-toggle-icon">▼</div>
            </div>
            <div className={`reports-card-content ${isCollapsed ? 'collapsed' : ''}`}>
                {children}
            </div>
        </div>
    );
};

export default Card;
